import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {capitalizeEveryWord} from '../../lib/StringUtils';

import './style.less';

const HOME = 'home';

export default class BreadCrumb extends Component {
  static propTypes = {
    onShopFilters: PropTypes.func,
    onClearFilters: PropTypes.func,
    onSelect: PropTypes.func.isRequired,
    primary: PropTypes.string,
    secondary: PropTypes.string,
    filter: PropTypes.object
  };

  render() {
    let path = [{name: HOME, onClick: this.props.onSelect.bind(this, null, 0)}];
    if (this.props.primary) {
      path.push({
        name: this.props.primary,
        onClick: this.props.onSelect.bind(this, this.props.primary, 1)
      });
      if (this.props.secondary) {
        path.push({
          name: this.props.secondary,
          onClick: this.props.onSelect.bind(this, this.props.secondary, 2)
        });
      }
    }

    let breadcrumb = path.map((pathObj, index) => {
      let key = pathObj.name + index;
      return <li onClick={pathObj.onClick} key={key}><span>{pathObj.name}</span></li>;
    });

    let filtersLink = null;
    if (this.props.onShopFilters && this.props.onClearFilters && this.props.filter) {
      let filterNameString = capitalizeEveryWord(this.props.filter.name);
      filtersLink = <div>
        <a className="text" onClick={this.props.onShopFilters.bind(this, this.props.filter)}>
          Shop All {filterNameString} Products
        </a>
        <a className="link" onClick={this.props.onClearFilters}>
          Clear Filters
        </a>
      </div>;
    }

    return (
      <div className={`breadcrumb-component ${this.props.className}`}>
        <div className="breadcrumb">
          <ul>
            {breadcrumb}
          </ul>
        </div>
        {this.props.children}
        <div className="filter-actions">
          {filtersLink}
        </div>
      </div>);
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/BreadCrumb/index.jsx
 **/